import { buildParams, CoreAPI } from '../../../Services/CoreAPI'

export const obtainSerieByFilter = async (filter) => {
  let endpoint = '/v1/serie'

  if (filter) {
    const params = buildParams(filter)
    endpoint = `/v1/serie?${params.toString()}`
  }

  const resp = await CoreAPI.get(endpoint)

  const {
    data: list = [],
    pagination: { totalPages = 1 } = {}
  } = resp

  if (list?.data) {
    return { list: list.data, totalPages }
  } else {
    return { list, totalPages }
  }
}

export const obtainSerieById = async (serieId) => {
  const endpoint = `/v1/serie/${serieId}`
  const resp = await CoreAPI.get(endpoint)

  if (resp.data?.data) {
    return resp.data.data
  }

  return resp.data
}

export const createSerie = async (data) => {
  const endpoint = '/v1/serie'
  const resp = await CoreAPI.post(endpoint, data)
  return resp.data
}

export const updateSerie = async (serieId, data) => {
  const endpoint = `/v1/serie/${serieId}`
  const resp = await CoreAPI.put(endpoint, data)
  return resp.data
}

export const deleteSerie = async (serieId) => {
  const endpoint = `/v1/serie/${serieId}`
  const resp = await CoreAPI.delete(endpoint)
  return resp.data
}
